class MiniCartRecommendations extends HTMLElement {
  selectors = {
    fragment: '[data-mini-cart-recommendation-el="fragment"]',
    list: '[data-mini-cart-recommendation-el="list"]',
    select: '[data-mini-cart-recommendation-el="select"]',
    variantInput: '[data-mini-cart-recommendation-el="variantInput"]',
    defaultState: '[data-mini-cart-recommendation-el="default-state"]',
  }

  connectedCallback () {
    this.limit = window.bao.exposed_liquid_settings.productRecommendationLimit
    this.lastAddedProductId

    this.parentProductIds = JSON.parse(this.querySelector('[data-mini-cart-recommendation-el="parent-product-ids"]').textContent).parentProductIds
    this.cartItems = document.querySelector('cart-items')

    this.recommendationId = this.parentProductIds.length > 0 ? '063e12517114961b364e' : '73f817848e1df3cd5976'

    onTagalysReady(() => {
      this.fetchRecommendations(this.recommendationId)
      document.addEventListener('fostrCartUpdateEvent', event => this.handleExternalCartUpdate(event))
    })
  }

  disconnectedCallback () {
    document.removeEventListener('fostrCartUpdateEvent', event => this.handleExternalCartUpdate)
  }

  setEventListeners () {
    this.querySelectorAll('form').forEach(form => {
      form.addEventListener('submit', (event) => {
        event.preventDefault()
        this.onSubmitHandler(form)
      })

      if (form.querySelector(this.selectors.select)) {
        form.querySelector(this.selectors.select).addEventListener('change', (event) => {
          event.preventDefault()
          this.onChangeHandler(form)
          this.gaEventSelectSize(event)
        })
      }
    })
  }

  fetchRecommendations (recommendationId) {
    window.Tagalys.APIConnector.Recommendations.call({
      params: {
        recommendationId: recommendationId,
        productIds: this.parentProductIds,
        count: 5
      },
      onSuccess: (response, helpers) => {
        const { products } = response
        this.renderProducts(products)
      },
      onFailure: (response, helpers) => {
        this.setAttribute('hidden', '')
        console.error('Failed to fetch recommendations', response)
      }
    })
  }

  renderProducts (recommendations) {
    const list = this.querySelector(this.selectors.list)
    list.innerHTML = recommendations.map((product, index) => {
      return window.theme.tagalys.recommendations.templates.miniCartListItem(product, index)
    }).join('')
  }



  /**
   * Handles the form submission.
   *
   * This async function submits a form using a fetch request, then updates the view with the response.
   * The function also puts the form's submit button in a loading state during this process.
   *
   * @async
   * @param {HTMLFormElement} form - The form to be submitted.
   *
   * @throws Will throw an error if the fetch request fails.
  */
  onChangeHandler (form) {
    form.querySelector(this.selectors.variantInput).value = event.currentTarget.value
  }

  async onSubmitHandler (form) {
    const submitButton = form.querySelector('[type="submit"]')
    if (submitButton.classList.contains('loading')) return

    this.handleLoadingState(submitButton)

    const config = window.fetchConfig('javascript')
    config.headers['X-Requested-With'] = 'XMLHttpRequest'
    delete config.headers['Content-Type']

    const formData = new FormData(form)
    formData.append(
      'sections',
      this.cartItems.getSectionsToRender().map(section => section.id),
    )
    formData.append('sections_url', window.location.pathname)
    config.body = formData

    try {
      const response = await fetch(`${window.routes.cart_add_url}`, config)

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()

      const addToCartEvent = new CustomEvent('GA_ADD_TO_CART', {
        detail: {
          formName: 'minicartRecommendations',
          item: data,
        },
      })
      window.dispatchEvent(addToCartEvent)

      this.cartItems.renderContents(data)
      await this.cartItems.checkGifts()
    } catch (error) {
      console.error('Error submitting form:', error)
    }
  }

  /**
    * Modifies the element's state to a loading state.
    *
    * @param {HTMLElement} el - The element that needs to be in the loading state.
    */

  handleLoadingState (el) {
    el.querySelector(this.selectors.defaultState).style.display = 'none'
    el.setAttribute('aria-disabled', true)
    el.classList.add('loading')
    el.querySelector('.loading-overlay__spinner').classList.remove(
      'hidden',
    )
  }

  /**
   * Extracts product ID from an event object.
   *
   * @param {Object} event - Event object from which the product ID will be extracted.
   * @return {(string|undefined)} productId - The ID of the product if it exists, otherwise undefined.
   *
   */

  getProductId (event) {
    let productId
    const { items, product_id } = event.detail.cart

    if (items) {
      productId = items.length > 0 ? items[0].product_id : false
    }

    if (product_id) {
      productId = product_id
    }

    return productId || false
  }

  /**
   * Given a product ID, this function fetches and displays product recommendations.
   *
   * @param {string} productId - The ID of the product for which to display recommendations.
  */
  displayRecommendations (productId) {
    this.fetchRecommendations(productId)
  }

  /**
    * This function clears the inner HTML of the class instance and hides it.
  */
  hideRecommendations () {
    this.innerHTML = ''
    this.style.display = 'none'
  }

  /**
   * Handles external updates to the cart. It checks the view type and takes action accordingly.
   * If the view type is 'desktop', it either fetches and displays product recommendations
   * or hides the recommendations, based on the returned productId.
   *
   * @param {Object} event - An event object that contains detail about the cart update.
  */
  handleExternalCartUpdate (event) {
    if (!event.detail || !event.detail.cart) {
      console.error('Invalid event object structure. Expected event.detail.cart.')
    }
    if (this.view !== 'desktop') return

    const productId = this.getProductId(event)

    if (this.lastAddedProductId === productId) return

    if (productId) {
      this.displayRecommendations(productId)
    } else {
      this.hideRecommendations()
    }
  }

  gaEventSelectSize (event) {
    const selectedIndex = event.target.selectedIndex
    const selectedOption = event.target.options[selectedIndex]

    window.dataLayer.push({
      event: 'minicart_select_size',
      miniCartSelectSize: {
        size_availability: selectedOption.dataset.gaVariableAvailable,
        product_name: selectedOption.dataset.gaVariableProduct,
        size_selected: selectedOption.dataset.gaVariableSize,
      },
    })
  }

  gaEventScroll (event) {
    const recsList = this.querySelector('[data-ga-el="miniCartRecommendations"]')

    if (!recsList) return

    recsList.addEventListener('scroll', (event) => {
      const scrollEventName = 'minicart_recs_scroll'
      const scrollEventIsPushed = window.dataLayer?.filter(obj => obj.event === scrollEventName).length > 0

      if (!scrollEventIsPushed) {
        window.dataLayer.push({
          event: scrollEventName,
        })
      }

      const scrollEndEventName = 'minicart_recs_scroll_end'
      const scrollEndEventIsPushed = window.dataLayer?.filter(obj => obj.event === scrollEndEventName).length > 0

      if (!scrollEndEventIsPushed) {
        const { offsetWidth, scrollLeft, scrollWidth, scrollHeight, scrollTop, offsetHeight } = event.target
        const scrollElEndHorizontal = scrollWidth === (scrollLeft + offsetWidth)
        const scrollElEndVertical = scrollHeight === (scrollTop + offsetHeight)

        if (scrollElEndHorizontal || scrollElEndVertical) {
          window.dataLayer.push({
            event: scrollEndEventName,
          })
        }
      }
    })
  }
}

customElements.define('mini-cart-recommendations', MiniCartRecommendations)
